
<template>
    <!-- note: these DIVs with PHD & l-main class simulates classes in integration without breaking the other front-end pages that aren't PHD.  Do not copy these over. -->
    <div class="PHD">
        <div class="l-main">
            <div class="container">
                <p class="secondary-tertiary-nav">SECONDARY TERTIARY NAV</p>
                <!-- May be take a look at how Project\Heart-FrontEnd\demo\pages\layouts\stroke-group-finder.vue accepts data,
                and then how Project\Heart-FrontEnd\src\app\components\stroke-group-selector.vue uses that data to do cool Vue stuff,
                loop through things, do functions etc. to be able to loop through nav links -->

                <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eum mollitia nam eaque architecto aut voluptatum totam harum! Dolor, placeat dolorem natus optio facilis quasi laboriosam, aliquid corporis, reprehenderit sapiente iusto!</p>
                <p>Corrupti consequuntur animi officia eaque, voluptas laudantium, pariatur omnis praesentium eum perferendis voluptatibus soluta nulla temporibus! Enim repudiandae natus quidem ad aspernatur, fugit, quibusdam quasi, fugiat asperiores pariatur ipsam magni.</p>
                <!-- Dev Notes on Data: 
                    In the integrated environment, the data can be inlined into the below custom component space, or added as a variable (as see on other data driven components).

                    The variable method would look like this:
                    <script>
                        // as always, the variable 'demoData' seen below can be named anythign, and it should be UNIQUE.  This method declares a globally scoped variable.
                        var demoData = {
                            showAll: false,
                            navItems: [
                                {
                                    active: true, // should only be on one item, see full notes below
                                    open: false, // always false
                                    text: 'first menu item',
                                    url: '#', // always # - this link is non-functional
                                    subNav: [
                                        {
                                            text: 'subMenuItem',
                                            url: '#'
                                        },
                                        {
                                            active: true, // should only be on one item, and only if the parent is active.  See full notes below
                                            text: 'subMenuItem 2',
                                            url: 'https://xcentium.com',
                                            target: '_blank' // OPTIONAL
                                        }
                                    ]
                                },
                                {
                                    open: false,
                                    text: 'first menu item',
                                    url: '#',
                                    subNav: [
                                        {
                                            text: 'subMenuItem',
                                            url: '#'
                                        },
                                        {
                                            text: 'subMenuItem 2',
                                            url: 'https://google.com',
                                            target: '_blank' // OPTIONAL
                                        }
                                    ]
                                }
                            ]
                        }
                    </script>

                    See full data structure example at the bottom of this file
                -->
                <!-- Dev Note: The actual component for integration is here! -->
                <phd-nav-secondary-tertiary :nav-data="demoData"></phd-nav-secondary-tertiary>

                <!-- Dev Notes: 
                    The data structure and notes about it can be found at the bottom of this file.
                -->

                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus, ad? Ullam ipsum voluptatem perferendis mollitia rem voluptatibus nesciunt dolores perspiciatis? Necessitatibus nobis tenetur consequatur delectus nemo ab reprehenderit itaque qui.</p>
                <p>Quis aspernatur illum neque! Soluta pariatur reiciendis ipsam beatae mollitia in dolore illum non, quia quas quidem. Quos sequi incidunt similique aspernatur amet recusandae quasi rem, maiores porro! Placeat, ipsum.</p>
                <p>Voluptatum error sapiente ab unde labore quisquam sequi ullam voluptate mollitia, consequatur eligendi saepe perspiciatis delectus hic ratione optio ut aperiam fuga totam cupiditate veniam! Consequatur facilis accusantium perferendis nesciunt.</p>
                <p>Beatae, dignissimos cumque deleniti quia, excepturi nulla aut possimus deserunt ad distinctio obcaecati consectetur facilis tenetur. Pariatur saepe, sunt distinctio, incidunt odio accusantium culpa laboriosam corrupti libero quos temporibus a.</p>
                <p>Quisquam id mollitia eveniet hic officiis maiores asperiores iste minus suscipit nesciunt modi ducimus necessitatibus est tempore, quam doloribus! Molestiae distinctio tenetur voluptatibus et sequi, consequatur vel numquam quibusdam cupiditate.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // This should be the name of your variable (make it unique), and can be anything.  This is what goes in the :nav-data="" attrubite of the component.
            demoData: {
                // showAll should default to false
                showAll: false,
                // This is the array of navigation objects for the secondary nav (first level).
                navItems: [
                    // each object here has 4 required and 1 optional key:value pair.
                    {
                        // this example shows the REQUIRED items
                        // 'open' should always be false
                        open: false,
                        text: 'Submit Science',
                        // this key:value pair is where the tertiary (sub-nav) links are stored, in an array of objects
                        subNav: [
                            // each object here should simply have a URL and a text value.  These are the required items.
                            {
                                text: '1 subMenuItem',
                                url: '#'
                            },
                            {
                                text: '1 subMenuItem 2',
                                url: '#'
                            }
                        ]
                    },
                    {
                        // this example show all 4 REQUIRED items, and the 1 OPTIONAL item.
                        // 'active' is the OPTIONAL item... technically, one item should be active, and it relates to which page is being displayed.  This makes that items show up 'bold' to indicate the current category of the page the user is on
                        open: false,
                        text: 'Programming',
                        // this is a more robust example of what you can put in here.  While there are 2 required items (text & url), there are also 2 optional items.

                        subNav: [
                            {
                                text: 'Programming by Community',
                                url: '#',
                                // 'target' is the first OPTIONAL key:value pair, and it does exactly what you think it does.  In the event, for some reason, that the client wants to change the target attribute of one of these links, this will take care of that
                                target: '_blank'
                            },
                            {
                                // 'active' is the other OPTIONAL key:value pair here.  Technically, ONE tartiary item in the data set should be active to represent the current page.  This will be represented on mobile as 'bold' to let the user know that's the current page.  Note that the parent item (category) should also have an "active: true" if there is one in this list.
                                // active: true,
                                text: 'CV Nursing Symposium',
                                url: '#'
                            },
                            {
                                text: 'Late-Breaking Science (Scientific Sessions)',
                                url: '#'
                            },
                            {
                                text: 'Health Tech & Innovation Summit',
                                url: '#'
                            },
                            {
                                text: 'Science & Technology Hall Highlights and some other stuff to make this longer',
                                url: '#'
                            },
                            {
                                text: 'Live STreaming',
                                url: '#'
                            },
                            {
                                text: 'Maintenance of Certification',
                                url: '#'
                            },
                            {
                                text: 'CME/CE Credit',
                                url: '#'
                            },
                            {
                                text: 'For Presenters and Moderators',
                                url: '#'
                            }
                        ]
                    },
                    {
                        open: false,
                        text: 'Awards',
                        subNav: [
                            {
                                text: 'google plz',
                                url: 'https://google.com',
                                target: '_blank'
                            },
                            {
                                text: 'subMenuItem 2',
                                url: '#'
                            },
                            {
                                text: 'subMenuItem 3',
                                url: '#'
                            },
                            {
                                text: 'subMenuItem 4',
                                url: '#'
                            },
                            {
                                text: 'subMenuItem 5',
                                url: '#'
                            },
                            {
                                text: 'subMenuItem six',
                                url: '#'
                            },
                            {
                                text: 'subMenuItem 7',
                                url: '#'
                            },
                            {
                                text: 'subMenuItem 8',
                                url: '#'
                            }
                        ]
                    },
                    {
                        open: false,
                        text: 'Science & Technology Hall',
                        subNav: [
                            {
                                text: 'subMenuItem',
                                url: '#'
                            },
                            {
                                active: true,
                                text: 'subMenuItem 2',
                                url: '#'
                            }
                        ]
                    },
                    {
                        text: 'Science News',
                        url: '#',
                        target: '_blank' // link target, leave off if none is desired.
                    },
                    {
                        open: false,
                        text: 'Live Streaming',
                        subNav: [
                            {
                                text: 'subMenuItem',
                                url: '#'
                            },
                            {
                                text: 'subMenuItem 2',
                                url: '#'
                            }
                        ]
                    },
                    {
                        open: false,
                        text: 'Archive',
                        subNav: [
                            {
                                text: 'subMenuItem',
                                url: '#'
                            },
                            {
                                text: 'subMenuItem 2',
                                url: '#'
                            }
                        ]
                    }
                ]
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// demo/components/nav/phd-secondary-tertiary-nav.vue